<template>


    <div class="attract-loop">

    <video autoplay playsinline muted loop>
        <source src="videoloop.mp4" type="video/mp4">
    </video>
    </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'attract-loop',
  components: {
  
  }
}
</script>

<style scoped>


  .attract-loop {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
  }

  .attract-loop video {
    width: 100%;
  }

</style>
